import * as tokens from '../../../tokens/typography.generated.js';
export const componentTypography = {
    typography: {
        navigation: {
            textLink: {
                sm: {
                    label: {
                        normal: tokens.CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_NORMAL
                    }
                },
                md: {
                    label: {
                        normal: tokens.CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_NORMAL
                    }
                }
            }
        },
        ui: {
            value: {
                sm: {
                    caption: tokens.CMP_TYPOGRAPHY_UI_VALUE_SM_CAPTION,
                    label: tokens.CMP_TYPOGRAPHY_UI_VALUE_SM_LABEL
                }
            },
            md: {
                caption: tokens.CMP_TYPOGRAPHY_UI_VALUE_MD_CAPTION,
                label: tokens.CMP_TYPOGRAPHY_UI_VALUE_MD_LABEL
            },
            lg: {
                caption: tokens.CMP_TYPOGRAPHY_UI_VALUE_LG_CAPTION,
                label: tokens.CMP_TYPOGRAPHY_UI_VALUE_LG_LABEL
            }
        }
    }
};
//# sourceMappingURL=component.js.map